module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/notokr-regular.woff2
// module id = xIeb
// module chunks = 0